import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api_deleteSavedSearchRecord = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(hash) {
    var _res$data;
    var url, data, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          url = "/saved-search/delete";
          data = {
            hash: hash
          };
          _context.n = 1;
          return fetcher(null, true).post(url, data);
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api_deleteSavedSearchRecord(_x) {
    return _ref.apply(this, arguments);
  };
}();